import { render, staticRenderFns } from "./AchievementsPerCompetenceView.vue?vue&type=template&id=ff42bd4a&scoped=true"
import script from "./AchievementsPerCompetenceView.vue?vue&type=script&lang=js"
export * from "./AchievementsPerCompetenceView.vue?vue&type=script&lang=js"
import style0 from "./AchievementsPerCompetenceView.vue?vue&type=style&index=0&id=ff42bd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff42bd4a",
  null
  
)

export default component.exports